/* SK Products - Slider drag/wheel + añadir al carrito */
(function () {

  /* Inicializa un slider individual */
  function initSlider(slider) {
    if (slider.getAttribute('data-slider-init')) return;
    slider.setAttribute('data-slider-init', 'true');

    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var didDrag = false;

    slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      /* No iniciar drag al pulsar una flecha de la mini-galeria */
      if (e.target.closest('.sk-products__img-arrow')) return;
      isDown = true;
      didDrag = false;
      slider.classList.add('sk-products__slider--grabbing');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
    });

    slider.addEventListener('mouseleave', function () {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('sk-products__slider--grabbing');
    });

    slider.addEventListener('mouseup', function () {
      if (!isDown) return;
      isDown = false;
      slider.classList.remove('sk-products__slider--grabbing');
    });

    slider.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      didDrag = true;
      var x = e.pageX - slider.offsetLeft;
      slider.scrollLeft = scrollLeft - (x - startX) * 1.5;
    });

    /* Prevenir click en links al terminar un drag */
    slider.addEventListener('click', function (e) {
      if (didDrag) {
        e.preventDefault();
        e.stopPropagation();
        didDrag = false;
      }
    }, true);

    /* Mini-galeria: pasar las imagenes de la card con las flechas (wrap circular) */
    slider.addEventListener('click', function (e) {
      var arrow = e.target.closest('.sk-products__img-arrow');
      if (!arrow || didDrag) return;

      e.preventDefault();
      e.stopPropagation();

      var wrapper = arrow.closest('.sk-products__image-wrapper');
      if (!wrapper) return;

      var imgs = wrapper.querySelectorAll('.sk-products__image');
      if (imgs.length < 2) return;

      var current = 0;
      for (var i = 0; i < imgs.length; i++) {
        if (imgs[i].classList.contains('sk-products__image--active')) { current = i; break; }
      }

      var dir = arrow.classList.contains('sk-products__img-arrow--next') ? 1 : -1;
      var next = (current + dir + imgs.length) % imgs.length;

      imgs[current].classList.remove('sk-products__image--active');
      imgs[next].classList.add('sk-products__image--active');

      /* La flecha izquierda solo aparece si no estamos en la primera imagen */
      var prevBtn = wrapper.querySelector('.sk-products__img-arrow--prev');
      if (prevBtn) prevBtn.classList.toggle('sk-products__img-arrow--hidden', next === 0);
    });

    /* Wheel vertical → scroll horizontal */
    slider.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaY) < Math.abs(e.deltaX)) return;
      var maxScroll = slider.scrollWidth - slider.clientWidth;
      if (maxScroll <= 0) return;
      if ((e.deltaY < 0 && slider.scrollLeft <= 0) || (e.deltaY > 0 && slider.scrollLeft >= maxScroll - 1)) return;
      e.preventDefault();
      slider.scrollLeft += e.deltaY;
    }, { passive: false });

    /* Añadir al carrito */
    slider.addEventListener('click', function (e) {
      var btn = e.target.closest('.sk-products__action-btn--cart');
      if (!btn || didDrag) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = btn.dataset.variantId;
      if (!variantId) return;

      if (btn.classList.contains('sk-products__action-btn--loading')) return;
      btn.classList.add('sk-products__action-btn--loading');

      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      /* Pedir sections del drawer para que la respuesta incluya el HTML re-renderizado */
      var cartItemsComp = document.querySelector('cart-items-component[data-section-id]');
      var sectionId = cartItemsComp ? cartItemsComp.dataset.sectionId : '';
      if (sectionId) formData.append('sections', sectionId);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          btn.classList.remove('sk-products__action-btn--loading');

          if (data.status) {
            console.error('Error al añadir:', data.description || data.message);
            return;
          }

          btn.classList.add('sk-products__action-btn--added');
          setTimeout(function () {
            btn.classList.remove('sk-products__action-btn--added');
          }, 1500);

          /* Actualizar contador + cart:update con sections reales + ABRIR el drawer
             (efecto accion/reaccion, igual que en los listados de coleccion) */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            var counters = document.querySelectorAll('[data-cart-count]');
            for (var c = 0; c < counters.length; c++) counters[c].textContent = cart.item_count;

            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: cart, data: { sections: data.sections || {}, itemCount: cart.item_count } },
            }));

            var drawer = document.querySelector('cart-drawer-component');
            if (drawer && drawer.showDialog) drawer.showDialog();
          });
        })
        .catch(function () {
          btn.classList.remove('sk-products__action-btn--loading');
        });
    });
  }

  /* Inicializar sliders existentes */
  var sliders = document.querySelectorAll('.sk-products__slider');
  sliders.forEach(function (slider) {
    initSlider(slider);
  });

  /* Reinicializar al cargar seccion en el Customizer */
  document.addEventListener('shopify:section:load', function (e) {
    var newSliders = e.target.querySelectorAll('.sk-products__slider');
    if (newSliders.length) {
      newSliders.forEach(function (slider) {
        initSlider(slider);
      });
    }
  });

})();
